<template>
    <span
        class="sort-direction"
        @click="setSort(name)"
    >
        <span v-html="title"></span>
        <i
            :class="'fa-' + sort"
            class="fa"
        />
    </span>
</template>

<script>
import Bus from '../../event-bus';

export default {
    props: {
        sort: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
    },
    methods: {
        setSort(name) {
            Bus.$emit('setSort', name);
        },
    },
};
</script>
